var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "contents" } }, [
    _c(
      "div",
      { staticClass: "contents_wrap" },
      [
        _c("skp-breadcrumbs", {
          on: {
            "page-title": function(val) {
              return (_vm.pageTitle = val)
            }
          }
        }),
        _vm._v(" "),
        _c("h2", { staticClass: "pg_title" }, [
          _vm.isServiceBulletin || _vm.isLocalServiceBulletin
            ? _c(
                "a",
                { staticClass: "active", attrs: { href: "javascript:" } },
                [
                  _vm._v(
                    _vm._s(_vm.pageTitle) +
                      " - " +
                      _vm._s(_vm.$t("BUTTON.GLOBAL.LIST"))
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !(_vm.isServiceBulletin || _vm.isLocalServiceBulletin)
            ? _c("span", [
                _vm._v(
                  _vm._s(_vm.pageTitle) +
                    " - " +
                    _vm._s(_vm.$t("BUTTON.GLOBAL.LIST"))
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isHHPAvailable && _vm.isServiceBulletin
            ? _c(
                "a",
                {
                  attrs: { href: "javascript:" },
                  on: {
                    click: function($event) {
                      return _vm.moveHHP($event)
                    }
                  }
                },
                [_vm._v("\n                Mobile (English)\n            ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isHHPAvailable && _vm.isLocalServiceBulletin
            ? _c(
                "a",
                {
                  attrs: { href: "javascript:" },
                  on: {
                    click: function($event) {
                      return _vm.moveHHP($event)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                Mobile (Other Languages)\n            "
                  )
                ]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.getCondition !== null
          ? _c("knowledge-search", {
              attrs: { boardId: _vm.getBoardId, condition: _vm.getCondition },
              on: { "current-page": _vm.setCurrentPage }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.isLoading
          ? _c("div")
          : _c("div", [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "resize",
                      rawName: "v-resize",
                      value: _vm.setGridResizeColumn,
                      expression: "setGridResizeColumn"
                    }
                  ],
                  staticClass: "grid_wrap"
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.getBoardCreationYN == "Y",
                          expression: "getBoardCreationYN == 'Y'"
                        }
                      ],
                      staticClass: "btn_wrap"
                    },
                    [
                      _vm.erpNewBoardIds.includes(_vm.boardId)
                        ? _c(
                            "a",
                            {
                              staticClass: "btn_white",
                              attrs: { href: "javascript:" },
                              on: { click: _vm.excelDownload }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("BUTTON.GLOBAL.EXCELDOWNLOAD"))
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "btn_gray",
                          attrs: {
                            href: "javascript:",
                            title: _vm.$t("BUTTON.GLOBAL.CREATE")
                          },
                          on: { click: _vm.createContents }
                        },
                        [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.CREATE")))]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("knowledge-list-grid", {
                    attrs: {
                      gridId: _vm.gridId,
                      data: _vm.gridData,
                      columns: _vm.columns,
                      options: _vm.options,
                      pageOptions: _vm.pageOptions,
                      click: _vm.contentClick,
                      isTotalCount: true
                    },
                    on: { "grid-total-count": _vm.setTotalCount }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "paginate" },
                [
                  _c("sdl-pagination", {
                    attrs: {
                      "current-page": _vm.currentPage,
                      "total-rows": _vm.totalCount,
                      "per-page": _vm.perPage
                    },
                    on: { change: _vm.movePage }
                  })
                ],
                1
              )
            ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-462cd04a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-462cd04a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/knowledge/KnowledgeList.vue
// module id = Q+Ue
// module chunks = 0